import { InjectionToken } from "@angular/core";
import type { EmptyCartRepository } from "../contracts/empty-cart.repository";

export const EMPTY_CART_REPOSITORY_TOKEN =
  new InjectionToken<EmptyCartRepository>("EMPTY_CART_REPOSITORY_TOKEN");
